import { FieldDesc } from '90.quickConnect.Models/models';

const getParentScope = (fullPathId: string): string => {
  const lastDotIndex = fullPathId.lastIndexOf('.');

  return lastDotIndex >= 0 ? fullPathId.substring(0, lastDotIndex) : '';
};

const getRefDependencies = (
  controlId: string,
  flattenFields: FieldDesc[],
  scopeFullPathId: string,
): FieldDesc | undefined => {
  const normalizedControlId = controlId.toUpperCase();

  // Une référence explicite par fullPathId est toujours prioritaire.
  const exactMatch = flattenFields.find((field) => field.fullPathId.toUpperCase() === normalizedControlId);

  if (exactMatch) {
    return exactMatch;
  }

  // Récupère les différentes instances du champ référencé.
  const candidates = flattenFields.filter((field) => field.id.toUpperCase() === normalizedControlId);

  if (candidates.length <= 1) {
    return candidates[0];
  }

  let currentScope = getParentScope(scopeFullPathId);

  // Priorité : même scope, parent, grand-parent, etc.
  while (currentScope) {
    const expectedFullPathId = `${currentScope}.${controlId}`.toUpperCase();

    const scopedField = candidates.find((field) => field.fullPathId.toUpperCase() === expectedFullPathId);

    if (scopedField) {
      return scopedField;
    }

    currentScope = getParentScope(currentScope);
  }

  // Fallback : recherche dans les sous-scopes du parent le plus proche
  // (scope frère, puis oncle, etc.).
  currentScope = getParentScope(scopeFullPathId);

  while (currentScope) {
    const normalizedScope = `${currentScope}.`.toUpperCase();

    const scopedField = candidates.find((field) => field.fullPathId.toUpperCase().startsWith(normalizedScope));

    if (scopedField) {
      return scopedField;
    }

    currentScope = getParentScope(currentScope);
  }

  return undefined;
};

export default getRefDependencies;
